import { useQuery } from "@apollo/client";
import { GET_MODULES_FOR_GLOBAL_WIZARD } from "@/modules/global-wizard/features/setup-module-settings/api/get-modules-for-global-wizard";

export function useModuleInfo({
  wantToSetup,
}: {
  wantToSetup: boolean | undefined;
}) {
  const { data, loading } = useQuery(GET_MODULES_FOR_GLOBAL_WIZARD, {
    skip: !wantToSetup,
  });

  return {
    modulesInfo: data?.getModulesInfo ?? [],
    loading,
  };
}
